// Single background-request counter for the whole app. Requests the admin
// makes on its own (polling, auto-refresh) carry edxr-bg=1 so the API
// doesn't record them as the user's activity (audit-trail spec §4.5).
//
// Two axios wrappers exist (src/shared/api.service.js and
// src/api-new/service/api.service.js — see that module's comment for why),
// and both mark their getAsync URLs off THIS counter, so a runInBackground()
// call started via either module's re-export marks a getAsync in either
// module. See api.service.background.test.js's "shared counter" case.
//
// The flag is only read synchronously at the start of getAsync, so a
// request the user starts in another tick is never marked.
let backgroundDepth = 0

export const runInBackground = fn => {
  backgroundDepth++
  try {
    return fn()
  } finally {
    backgroundDepth--
  }
}

export const markBackground = url => (backgroundDepth > 0 ? `${url}${url.includes('?') ? '&' : '?'}edxr-bg=1` : url)
